import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "addons-main" }
const _hoisted_2 = { class: "addons-main__wrapper" }
const _hoisted_3 = { class: "addons-main__header" }
const _hoisted_4 = { class: "addons-main__header-title h3" }
const _hoisted_5 = { class: "addons-main__list desktop" }
const _hoisted_6 = { class: "addons-main__list mobile" }
const _hoisted_7 = { class: "addons-main__list-item" }


import { useI18n } from "vue-i18n";
import { PropType } from "@vue/runtime-core";
import { AddonsItemStruct } from "@/struct/AddonsStruct";
import AddonsMainItem from "@/components/addons/AddonsMainItem.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { useRouter } from "vue-router";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddonsMain',
  props: {
  options: {
    type: Object as PropType<AddonsItemStruct[]>,
    required: true,
  },
},
  emits: ["action"],
  setup(__props, { emit: __emit }) {

const router = useRouter();

const { t } = useI18n();



const emits = __emit;

const goToAddons = () => {
  router.push("/addons");
};

const goToSpecificAddon = (item: AddonsItemStruct) => {
  console.log(item);
  emits("action", item);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)("addons.page.connectedOptions")), 1)
        ]),
        (__props.options.length > 2)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "addons-main__header-add button-small",
              onClick: goToAddons
            }, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("common.actions.add")), 1),
              _createVNode(BaseFigureForIcon, {
                icon: "plus",
                color: "secondary",
                size: "small",
                "is-button": ""
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(Swiper), {
          class: "addons-main__list-swiper",
          "slides-per-view": 3,
          "space-between": 10,
          "centered-slides": false
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item, index) => {
              return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
                default: _withCtx(() => [
                  _createVNode(AddonsMainItem, {
                    option: item,
                    onClick: ($event: any) => (goToSpecificAddon(item))
                  }, null, 8, ["option", "onClick"])
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createVNode(_unref(SwiperSlide), null, {
              default: _withCtx(() => [
                _createVNode(AddonsMainItem, {
                  "is-addition": "",
                  onClick: goToAddons
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "addons-main__list-item"
          }, [
            _createVNode(AddonsMainItem, {
              option: item,
              onClick: ($event: any) => (goToSpecificAddon(item))
            }, null, 8, ["option", "onClick"])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(AddonsMainItem, {
            "is-addition": "",
            onClick: goToAddons
          })
        ])
      ])
    ])
  ]))
}
}

})